/**
 * Export Validators
 * Zod schemas for export functionality
 */
import { z } from "zod";
import { ExportColumnKey } from "../types/export.js";
export const exportFormatSchema = z.enum(["csv", "excel", "pdf"]);
export const exportSourceSchema = z.enum(["results", "favorites", "job"]);
export const exportColumnSchema = z.object({
    key: z.string(),
    label: z.string(),
    enabled: z.boolean(),
});
export const exportColumnKeySchema = z.nativeEnum(ExportColumnKey);
export const exportOptionsSchema = z.object({
    format: exportFormatSchema,
    source: exportSourceSchema,
    columns: z.array(exportColumnSchema),
    name: z.string().trim().min(1).max(120).optional(),
    resultIds: z.array(z.union([z.number(), z.string()])).optional(), // For batch export (numbers for results, strings for job UUIDs)
    pdfColumns: z.array(exportColumnKeySchema).optional(), // For PDF column selection
    filters: z
        .object({
        jobId: z.string().optional(),
        batchListId: z.number().optional(),
        minPrice: z.number().optional(),
        maxPrice: z.number().optional(),
        minMileage: z.number().optional(),
        maxMileage: z.number().optional(),
        fuel: z.string().optional(),
        transmission: z.string().optional(),
    })
        .optional(),
});
//# sourceMappingURL=export.schema.js.map